import { optionStatus, featureFlagsStatuses } from './configurates';

export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      status: filter.status[0] ? filter.status : '*',
      updatedByName: filter.updatedByName[0] ? filter.updatedByName : '*',
      // Optional chaining: a filter restored from a URL saved before the owner
      // filter existed has no ownerName key at all.
      ownerName: filter.ownerName?.[0] ? filter.ownerName : '*',
      isTestTenant: filter.isTestTenant ? filter.isTestTenant === 'True' : '*',
      autoAssign: filter.autoAssign ? filter.autoAssign === 'True' : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};

export const mapStatusOptions = (currentStatus, customerIdsCount, t) => {
  if (currentStatus === featureFlagsStatuses.GlobalAssigned) {
    const hasCustomersAssigned = customerIdsCount > 0;
    return hasCustomersAssigned
      ? [
          {
            value: featureFlagsStatuses.Assigned,
            label: t('featureFlags:Assigned')
          },
          {
            value: featureFlagsStatuses.GlobalAssigned,
            label: t('featureFlags:GlobalAssigned')
          }
        ]
      : [
          {
            value: featureFlagsStatuses.New,
            label: t('featureFlags:New')
          },
          {
            value: featureFlagsStatuses.ReadyToDev,
            label: t('featureFlags:ReadyToDev')
          },
          {
            value: featureFlagsStatuses.ReadyToAssign,
            label: t('featureFlags:ReadyToAssign')
          },
          {
            value: featureFlagsStatuses.GlobalAssigned,
            label: t('featureFlags:GlobalAssigned')
          }
        ];
  }

  if (currentStatus === featureFlagsStatuses.Assigned) {
    return [
      {
        value: featureFlagsStatuses.Assigned,
        label: t('featureFlags:Assigned')
      },

      {
        value: featureFlagsStatuses.GlobalAssigned,
        label: t('featureFlags:GlobalAssigned')
      }
    ];
  }

  return optionStatus;
};
